import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Menu } from '../models/menu.model';
import { Restaurant } from '../models/restaurants.model';

@Injectable()
export class MenuStorageService {
  /** Observable de restaurante seleccionado */
  restaurant$ = new BehaviorSubject<Restaurant>({} as Restaurant);
  /** Observable de menu seleccionado */
  menu$ = new BehaviorSubject<Menu>({} as Menu);
  /**
   * Devuelve la cantidad de pixeles que se scrolearon
   * en la pantalla del menu
   */
  public scrollSubject = new BehaviorSubject<number>(0);
  /**
   * Observable que escucha el evento scroll
   */
  scroll$ = this.scrollSubject.asObservable();
  constructor(private ngZone: NgZone) {
    this.listenToScroll();
  }
  destroy() {
    window.removeEventListener('scroll', this.onScroll, true);
  }

  /**
   * Guarda la informacion del restaurante seleccionado
   *
   * @param restaurant info del restaurante
   */
  setRestaurant(restaurant: Restaurant): void {
    this.restaurant$.next(restaurant);
  }

  /**
   * Obtiene el observable del restaurante seleccionado
   *
   * @returns observable con la info del restaurante
   */
  getRestaurant(): Observable<any> {
    return this.restaurant$.asObservable();
  }

  /**
   * Guarda la informacion del menu seleccionado
   *
   * @param menu info del menu
   */
  setMenu(menu: Menu): void {
    this.menu$.next(menu);
  }

  /**
   * Obtiene el observable del menu seleccionado
   *
   * @returns observable con la info del menu
   */
  getMenu(): Observable<any> {
    return this.menu$.asObservable();
  }


  /**
   * Escucha el scroll de la pantalla del menu
   */
  private listenToScroll() {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', this.onScroll, true);
    });
  }
  /**
   * Devuelve la cantidad de pixeles que se scrolearon
   * en la pantalla del menu
   */
  private onScroll = () => {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    this.ngZone.run(() => {
      this.scrollSubject.next(scrollTop);
    });
  };
}
